import dispatcher from './dispatcher';
import {
  VIEW_LOGIN_ID,
  VIEW_LOGIN_ID_ERR,
  DID_LOGIN,
  DID_LOGOUT,
  ON_ERROR,
} from './Actions';
import { BASE_URL } from './AppConst';
import axios from 'axios';

export function GetLoginID() {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );
  axios
    .post('/students/get-ids', {})
    .then((res) => {
      const status = parseInt(res.data.status);

      if (status === 200) {
        const responseString = JSON.parse(JSON.stringify(res.data));
        let generated_ids = responseString.data;
        console.log(`From Axios ${JSON.stringify(generated_ids)}`);
        dispatcher.dispatch({
          type: VIEW_LOGIN_ID,
          payload: generated_ids,
        });
      } else {
        dispatcher.dispatch({
          type: VIEW_LOGIN_ID_ERR,
          payload: [],
        });
      }
    })
    .catch((error) => console.log(`Error Encountered ${error}`));
}

export function DoLogout() {
  dispatcher.dispatch({
    type: DID_LOGOUT,
  });
}

export const DoLogin = async (postData) => {
  const { user_id, pass_code } = postData;

  axios.defaults.baseURL = BASE_URL;

  try {
    const response = await axios.post('/login', {
      email: user_id,
      password: pass_code,
    });

    if (response.data) {
      dispatcher.dispatch({
        type: DID_LOGIN,
        payload: response.data,
      });
    } else {
      dispatcher.dispatch({
        type: DID_LOGIN,
        payload: [],
      });
    }
  } catch (err) {
    dispatcher.dispatch({
      type: ON_ERROR,
      payload: 'Login failed! User ID and Password does not match!',
    });
  }
};
